module.exports = __webpack_public_path__ + "static/scale-model-of-frank-lloyd-wright-wisconsin-in-madison-wisconsin-374908ed3921528fc6d880b0a99ad3ca.png";